// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XvRF7lW8xptKSFErANWn {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.zeaHsqvGLtK1XN6hrG2p {
  font-size: 1.5em;
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--dst-text);
}

.CvT95AdjbO2KzTkklZKk {
  padding: 12px 16px;
  margin-bottom: 20px;
  border-radius: 6px;
  font-size: 1em;
  border: 1px solid transparent;
}

.CvT95AdjbO2KzTkklZKk.ceHcKhHk4_pK0tztRI1l {
  background: var(--dst-error-bg);
  color: var(--dst-error-text);
  border-color: var(--dst-error-border);
}

.WXxOCYmPZCboBzst3k1X {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
  margin-bottom: 20px;
}

.mLkWtSK1iwzZQcvrg4iG {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.yrH8rlfpeeDcfm2nNbBn {
  font-weight: 600;
  font-size: 0.95em;
}

.KMv_IpH_iLy6iMaGOyAP {
  min-height: 40px;
  padding: 6px 10px;
  border: 1px solid var(--dst-input-border);
  border-radius: 4px;
  font-size: 0.95em;
  color: var(--dst-text);
  background: var(--dst-input-bg);
}

.VQ19FfBIXprUKeE17VK3 {
  padding: 10px;
  text-align: left;
  font-size: 0.88rem;
  color: var(--dst-muted);
}

.b_OW6lS2f5uJzhF62PeZ,
.ceHcKhHk4_pK0tztRI1l {
  text-align: center;
  padding: 20px;
  color: var(--dst-muted);
  font-style: italic;
}

.I_B81txln1CIPi9opi17 {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid var(--dst-table-border);
  border-radius: 8px;
  max-height: 70vh;
}

.NlLU8sZcwL9SwT9DQHrU {
  width: max-content;
  min-width: calc(180px + (var(--stats-columns, 1) * 56px));
  border-collapse: collapse;
  background: var(--dst-table-bg);
  table-layout: fixed;
}

.NlLU8sZcwL9SwT9DQHrU thead {
  position: sticky;
  top: 0;
  z-index: 10;
}

.NlLU8sZcwL9SwT9DQHrU thead th {
  background: var(--dst-table-head-bg);
  color: var(--dst-table-head-text);
  font-weight: 700;
  border-bottom: 2px solid var(--dst-table-border);
  padding: 0;
  height: 140px;
  position: relative;
}

.TO2xX9mNP7C0Xh2me5Yw {
  position: sticky;
  left: 0;
  z-index: 11;
  background: var(--dst-table-head-bg);
  text-align: left;
  padding: 10px 12px;
  font-weight: 700;
  min-width: 180px;
  width: 180px;
}

.NlLU8sZcwL9SwT9DQHrU tbody .TO2xX9mNP7C0Xh2me5Yw {
  background: var(--dst-table-bg);
  font-weight: 600;
  height: auto;
  border-bottom: 1px solid var(--dst-table-border);
}

.anvPrHzjOlM3i9dKombF {
  width: 56px;
  min-width: 56px;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  position: relative;
}

.vD4oxrTt8SZxbDPWoyS2 {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 0.82em;
  line-height: 1;
}

.NlLU8sZcwL9SwT9DQHrU td {
  padding: 8px 6px;
  text-align: center;
  border-bottom: 1px solid var(--dst-table-border);
  border-right: 1px solid var(--dst-table-border);
  word-break: break-word;
  min-width: 56px;
}

.NlLU8sZcwL9SwT9DQHrU tbody tr:hover {
  background: var(--dst-panel-subtle);
}

.iM2J9MrUHtkgbntw7uTI td,
.iM2J9MrUHtkgbntw7uTI .TO2xX9mNP7C0Xh2me5Yw {
  background: var(--dst-shift-total-bg);
  color: var(--dst-shift-total-text);
  font-weight: 700;
}

.bPbunEgEFjJRwO67Rjcb {
  background: var(--dst-shift-total-bg) !important;
  color: var(--dst-shift-total-text) !important;
  font-weight: 700;
}

.yUDnt1UsdhkhNZG8pXww td,
.yUDnt1UsdhkhNZG8pXww .TO2xX9mNP7C0Xh2me5Yw {
  background: var(--dst-dept-total-bg);
  color: var(--dst-dept-total-text);
  font-weight: 800;
}

.SDd_NgPTuq63NwjpdEZO {
  background: var(--dst-dept-total-bg) !important;
  color: var(--dst-dept-total-text) !important;
  font-weight: 800;
}

@media (max-width: 820px) {
  .XvRF7lW8xptKSFErANWn {
    padding: 12px;
  }

  .anvPrHzjOlM3i9dKombF {
    height: 120px;
    width: 48px;
    min-width: 48px;
  }

  .TO2xX9mNP7C0Xh2me5Yw {
    min-width: 120px;
    width: 120px;
  }

  .vD4oxrTt8SZxbDPWoyS2 {
    font-size: 0.8em;
  }

  .NlLU8sZcwL9SwT9DQHrU th,
  .NlLU8sZcwL9SwT9DQHrU td {
    font-size: 0.85em;
  }
}

@media (max-width: 600px) {
  .anvPrHzjOlM3i9dKombF {
    height: 106px;
    width: 42px;
    min-width: 42px;
  }

  .TO2xX9mNP7C0Xh2me5Yw {
    min-width: 104px;
    width: 104px;
  }

  .NlLU8sZcwL9SwT9DQHrU td {
    padding: 6px 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./assets/js/src/components/OfficerDashboard/tabs/DepartmentStats.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;EAChB,gDAAgD;EAChD,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,+CAA+C;EAC/C,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,qCAAqC;EACrC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".container {\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.title {\n  font-size: 1.5em;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: var(--dst-text);\n}\n\n.alert {\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  border-radius: 6px;\n  font-size: 1em;\n  border: 1px solid transparent;\n}\n\n.alert.error {\n  background: var(--dst-error-bg);\n  color: var(--dst-error-text);\n  border-color: var(--dst-error-border);\n}\n\n.filterBar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: flex-end;\n  margin-bottom: 20px;\n}\n\n.filterGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.label {\n  font-weight: 600;\n  font-size: 0.95em;\n}\n\n.select {\n  min-height: 40px;\n  padding: 6px 10px;\n  border: 1px solid var(--dst-input-border);\n  border-radius: 4px;\n  font-size: 0.95em;\n  color: var(--dst-text);\n  background: var(--dst-input-bg);\n}\n\n.caption {\n  padding: 10px;\n  text-align: left;\n  font-size: 0.88rem;\n  color: var(--dst-muted);\n}\n\n.loading,\n.error {\n  text-align: center;\n  padding: 20px;\n  color: var(--dst-muted);\n  font-style: italic;\n}\n\n.tableScrollWrapper {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  border: 1px solid var(--dst-table-border);\n  border-radius: 8px;\n  max-height: 70vh;\n}\n\n.table {\n  width: max-content;\n  min-width: calc(180px + (var(--stats-columns, 1) * 56px));\n  border-collapse: collapse;\n  background: var(--dst-table-bg);\n  table-layout: fixed;\n}\n\n.table thead {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.table thead th {\n  background: var(--dst-table-head-bg);\n  color: var(--dst-table-head-text);\n  font-weight: 700;\n  border-bottom: 2px solid var(--dst-table-border);\n  padding: 0;\n  height: 140px;\n  position: relative;\n}\n\n.stickyCol {\n  position: sticky;\n  left: 0;\n  z-index: 11;\n  background: var(--dst-table-head-bg);\n  text-align: left;\n  padding: 10px 12px;\n  font-weight: 700;\n  min-width: 180px;\n  width: 180px;\n}\n\n.table tbody .stickyCol {\n  background: var(--dst-table-bg);\n  font-weight: 600;\n  height: auto;\n  border-bottom: 1px solid var(--dst-table-border);\n}\n\n.rotatedHeader {\n  width: 56px;\n  min-width: 56px;\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  position: relative;\n}\n\n.rotatedText {\n  position: absolute;\n  bottom: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  font-size: 0.82em;\n  line-height: 1;\n}\n\n.table td {\n  padding: 8px 6px;\n  text-align: center;\n  border-bottom: 1px solid var(--dst-table-border);\n  border-right: 1px solid var(--dst-table-border);\n  word-break: break-word;\n  min-width: 56px;\n}\n\n.table tbody tr:hover {\n  background: var(--dst-panel-subtle);\n}\n\n.shiftTotalRow td,\n.shiftTotalRow .stickyCol {\n  background: var(--dst-shift-total-bg);\n  color: var(--dst-shift-total-text);\n  font-weight: 700;\n}\n\n.shiftTotalCell {\n  background: var(--dst-shift-total-bg) !important;\n  color: var(--dst-shift-total-text) !important;\n  font-weight: 700;\n}\n\n.departmentTotalRow td,\n.departmentTotalRow .stickyCol {\n  background: var(--dst-dept-total-bg);\n  color: var(--dst-dept-total-text);\n  font-weight: 800;\n}\n\n.departmentTotalCell {\n  background: var(--dst-dept-total-bg) !important;\n  color: var(--dst-dept-total-text) !important;\n  font-weight: 800;\n}\n\n@media (max-width: 820px) {\n  .container {\n    padding: 12px;\n  }\n\n  .rotatedHeader {\n    height: 120px;\n    width: 48px;\n    min-width: 48px;\n  }\n\n  .stickyCol {\n    min-width: 120px;\n    width: 120px;\n  }\n\n  .rotatedText {\n    font-size: 0.8em;\n  }\n\n  .table th,\n  .table td {\n    font-size: 0.85em;\n  }\n}\n\n@media (max-width: 600px) {\n  .rotatedHeader {\n    height: 106px;\n    width: 42px;\n    min-width: 42px;\n  }\n\n  .stickyCol {\n    min-width: 104px;\n    width: 104px;\n  }\n\n  .table td {\n    padding: 6px 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `XvRF7lW8xptKSFErANWn`,
	"title": `zeaHsqvGLtK1XN6hrG2p`,
	"alert": `CvT95AdjbO2KzTkklZKk`,
	"error": `ceHcKhHk4_pK0tztRI1l`,
	"filterBar": `WXxOCYmPZCboBzst3k1X`,
	"filterGroup": `mLkWtSK1iwzZQcvrg4iG`,
	"label": `yrH8rlfpeeDcfm2nNbBn`,
	"select": `KMv_IpH_iLy6iMaGOyAP`,
	"caption": `VQ19FfBIXprUKeE17VK3`,
	"loading": `b_OW6lS2f5uJzhF62PeZ`,
	"tableScrollWrapper": `I_B81txln1CIPi9opi17`,
	"table": `NlLU8sZcwL9SwT9DQHrU`,
	"stickyCol": `TO2xX9mNP7C0Xh2me5Yw`,
	"rotatedHeader": `anvPrHzjOlM3i9dKombF`,
	"rotatedText": `vD4oxrTt8SZxbDPWoyS2`,
	"shiftTotalRow": `iM2J9MrUHtkgbntw7uTI`,
	"shiftTotalCell": `bPbunEgEFjJRwO67Rjcb`,
	"departmentTotalRow": `yUDnt1UsdhkhNZG8pXww`,
	"departmentTotalCell": `SDd_NgPTuq63NwjpdEZO`
};
export default ___CSS_LOADER_EXPORT___;
